'use client';

import * as amplitude from '@amplitude/unified';

function initAmplitude() {
  if (typeof window !== 'undefined') {
    amplitude.initAll('3b4a40505afcb4dad56abf9772af55b3', {
      analytics: { autocapture: true },
      sessionReplay: { sampleRate: 1 }
    });
  }
}

initAmplitude();

export const Amplitude = () => null;
export default amplitude;
